module.exports = ".popup-wrapuli{ margin-left : 28%;}\r\n.colorRed{color: red;}"